export const GET_DASHBOARD_INFO_REQUEST = "GET_DASHBOARD_INFO_REQUEST";
export const GET_DASHBOARD_INFO_SUCCESS = "GET_DASHBOARD_INFO_SUCCESS";
